import { Button } from "@/components/ui/button";
import { useAuthModalStore, useSamplesModalStore } from "@/stores/ui";
import { HeroMarquee } from "@/components/marketing/HeroMarquee";
import { BrandMark } from "@/components/marketing/BrandMark";

export function Marketing() {
  const openAuth = useAuthModalStore((s) => s.openAt);
  const openSamples = useSamplesModalStore((s) => s.show);

  return (
    <div className="grid h-screen grid-rows-[auto_1fr] overflow-hidden">
      <header className="flex items-center justify-between gap-6 px-10 py-5 max-md:px-4">
        <BrandMark size="lg" />
        <div className="flex items-center gap-2">
          <Button variant="link" onClick={() => openAuth("login")}>
            登录
          </Button>
          <Button onClick={() => openAuth("login")}>登录使用</Button>
        </div>
      </header>

      <main className="grid grid-cols-[minmax(380px,1fr)_minmax(420px,1.2fr)] items-center gap-12 px-10 pb-10 max-[980px]:grid-cols-1 max-[980px]:px-5 max-[980px]:pb-5">
        <div className="flex max-w-[560px] flex-col gap-6 py-6">
          <p className="text-xs font-medium uppercase tracking-[0.18em] text-muted-foreground">
            Lumi · 影像生成 · 让创作有光
          </p>
          <h1 className="font-display text-[clamp(48px,7vw,88px)] font-medium leading-none tracking-[-0.035em] text-foreground">
            创作之光，
            <br />
            一触即燃。
          </h1>
          <p className="max-w-[480px] text-base leading-relaxed text-muted-foreground">
            Lumi 把世界顶级的 AI 影像模型汇聚成一束光 —— GPT-Image 2 的精准、nano-banana
            的灵敏、Flux 1.1 Pro 的细腻。商品图、模特图、品牌创意，照亮你想象的每一个角落。
          </p>
          <div className="mt-2 flex gap-3">
            <Button size="lg" onClick={() => openAuth("login")}>
              开始创作
            </Button>
            <Button size="lg" variant="ghost" onClick={openSamples}>
              查看样片
            </Button>
          </div>
          <div className="mt-4 flex flex-wrap items-center gap-x-3 gap-y-1 font-mono text-[11px] uppercase tracking-[0.06em] text-muted-foreground/70">
            <span>GPT-Image 2 · 字字清晰</span>
            <span className="h-[3px] w-[3px] rounded-full bg-muted-foreground/70" />
            <span>nano-banana · 一触即得</span>
            <span className="h-[3px] w-[3px] rounded-full bg-muted-foreground/70" />
            <span>Flux 1.1 Pro · 写实如真</span>
          </div>
        </div>

        <div className="max-[980px]:hidden">
          <HeroMarquee />
        </div>
      </main>
    </div>
  );
}
